// Lets the dev-only debug console observe every analytics event (its "Analytics Alerts" toggle)
// without the analytics service importing the store layer. Null — and so a no-op — unless the
// debug console registers itself, which it only does in dev builds.
type AnalyticsDebugTap = (eventName: string, params: Record<string, unknown>) => void;

let tap: AnalyticsDebugTap | null = null;

export function setAnalyticsDebugTap(next: AnalyticsDebugTap | null): void {
  tap = next;
}

export function notifyAnalyticsDebugTap(eventName: string, params: Record<string, unknown>): void {
  tap?.(eventName, params);
}
